/// <reference lib="dom" />
export const now = typeof performance !== "undefined"
    ? () => performance.now()
    : () => Date.now();
//# sourceMappingURL=now.js.map